import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-grid-system';
import Radium from 'radium';
import { getLocalizedText as text } from '@vp-dst/localization-util';

import { colors } from 'settings/theme';
import Price from 'components/vistaprintUILibrary/Price';
import Typography from 'components/vistaprintUILibrary/Typography';
import SectionHeading from 'components/SectionHeading';

const RadiumTypography = Radium(Typography);

function AllProductsList(props) {
  const {
    productsByPriceMultiplier,
    productOnClick,
  } = props;

  return (
    <div>
      <Row>
        <Col>
          <SectionHeading
            text={text('product-list-and-pricing')}
            alignment="center"
            containerStyle={{
              marginBottom: 40,
            }}
          />
        </Col>
      </Row>
      <Row
        style={{ // this is probably bad, but the api doesn't support centering columns when there aren't enough to fill all 12 slots
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        {Object.keys(productsByPriceMultiplier).map((priceMultiplier) => {
          const products = productsByPriceMultiplier[priceMultiplier];

          if (products.length === 0) {
            return null;
          }

          return (
            <Col
              xs={12}
              sm={3}
              key={`all-products-list-option-${priceMultiplier}`}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  marginBottom: 20,
                }}
              >
                <div
                  style={{
                    display: 'flex',
                  }}
                >
                  <Price
                    priceHTML={products[0].localizedPriceHTML}
                    style={{
                      fontSize: '1.2em',
                      fontWeight: 'bold',
                    }}
                  />
                  <Typography
                    text={text('products')}
                    style={{
                      fontWeight: 'bold',
                      marginLeft: 4,
                    }}
                  />
                </div>
                {products.map(product => (
                  <button
                    key={`all-products-list-option-${product.localizedName.split(' ').join('')}`}
                    type="button"
                    style={{
                      display: 'block',
                      border: 'none',
                      backgroundColor: 'unset',
                      textAlign: 'left',

                      paddingTop: 7,
                      paddingBottom: 7,
                      cursor: 'pointer',
                    }}
                    onClick={() => productOnClick(product)}
                  >
                    <RadiumTypography
                      text={product.localizedName}
                      style={{
                        ':hover': {
                          color: colors.blueMid,
                        },
                      }}
                    />
                  </button>
                ))}
              </div>
            </Col>
          );
        })}
      </Row>
    </div>
  );
}

AllProductsList.propTypes = {
  productOnClick: PropTypes.func.isRequired,
  productsByPriceMultiplier: PropTypes.objectOf(
    PropTypes.arrayOf(PropTypes.shape({
      localizedName: PropTypes.string,
      localizedPriceHTML: PropTypes.string,
      requestURL: PropTypes.string,
    })),
  ).isRequired,
};

export default AllProductsList;



// WEBPACK FOOTER //
// ./src/components/AllProductsList.js